<template>
  <div class="lp-check-group-container">
    <div class="lp-check-container" v-for="(item, idx) in list" :key="'chk'+idx" @click="clickCheck(item)">
      <div class="sel-btn" :class="{'selected': isSelected(item) }">
        <i v-if="isSelected(item)" class="material-icons checked-icon">check</i>
      </div>
      <div class="lp-label">{{ !label_name? item : item[label_name] }}</div>
    </div>
  </div>
</template>

<script>
  export default {
    props: {
      list: {
        type: Array
      },
      data: {
        type: Array
      },
      label_name: {
        type: String
      },
      value_name: {
        type: String
      }
    },
    created() {
    },
    data() {
      return {}
    },
    watch: {},
    methods: {
      clickCheck(item) {
        if (this.value_name) {
          if (!this.data.includes(item[this.value_name])) {
            this.data.push(item[this.value_name]);
          }
          else {
            let index = this.data.indexOf(item[this.value_name])
            if (index >= 0) {
              removeIndex(this.data,index);
            }
          }
        }
        else {
          if (!this.data.includes(item)) {
            this.data.push(item);
          }
          else {
            for (let i = 0; i < this.data.length; i++) {
              if (this.data[i] === item) {
                removeIndex(this.data, i);
                break;
              }
            }
          }
        }
        this.$emit('check');
      },
      isSelected(item) {
        if (this.value_name) {
          if (!this.data.includes(item[this.value_name])) return false;
          else return true;
        }
        else {
          if (!this.data.includes(item)) return false;
          else return true;
        }
      }
    }
  }
</script>

<style lang="stylus" type="stylus" scoped>
  @import '~assets/css/lp_variable'
  .lp-check-group-container
    display grid
    grid-template-columns repeat(4, 1fr)
    grid-column-gap 8px
    grid-row-gap 4px

  .lp-check-container
    cursor pointer
    display flex
    align-items center

  .sel-btn
    width 16px
    height 16px
    border-radius 3px
    margin auto 0
    margin-right 8px
    border 1px solid #dddddd
    background-color white
    display inline-block
    text-align center

  .selected
    background-color $primary
    border 1px solid $primary

  .checked-icon
    color #fff
    font-size .8rem
    font-weight bold
    padding 1.5px
    display flex
    align-items center
    justify-content center

  .lp-label
    flex 1
    font-size 0.9rem
    line-height 17px

</style>
